module.exports = __webpack_public_path__ + "img/t18.7fb675b8.png";